import * as React from 'react';

import { V3 } from '../../api_request';
import { Paths } from '../../shared/url_helpers';

import CoreLink from '@reverbdotcom/commons/dist/components/core_link';

interface Response {
  horizontal_mosaic_tile: Tile;
  vertical_mosaic_tile: Tile;
  left_square_mosaic_tile: Tile;
}

interface Tile {
  image_title: string;
  image_subtitle: string;
  id: number;
  _links: {
    url: {
      href: string;
    };
    cropped_image: {
      href: string;
    };
  };
}

function MosaicTile({ tile }) {
  const image = tile._links?.cropped_image?.href;
  const link = tile._links?.url?.href;
  return (
    <li className="mosaic-tile">
      <CoreLink
        to={link}
        className="mosaic-tile__link"
        trackName="HomepageMosaic"
      >
        <div
          className="mosaic-tile__image"
          style={{ backgroundImage: `url('${image}')` }}
        >
        </div>
        <div className="mosaic-tile__text">
          <p className="mosaic-tile__subtitle">
            {tile.image_subtitle}
          </p>
          <h4 className="mosaic-tile__title">
            {tile.image_title}
          </h4>
        </div>
      </CoreLink>
    </li>
  );
}

function PlaceholderTile() {
  return (
    <li className="mosaic-tile mosaic-tile--loading">
      <div className="mosaic-tile__link">
        <div className="mosaic-tile__image" />
        <div className="mosaic-tile__text">
          <div className="mosaic-tile__subtitle" />
          <div className="mosaic-tile__title" />
        </div>
      </div>
    </li>
  );
}

export default function HomepageMosaic() {
  const [tiles, setTiles] = React.useState<Response | null>(null);

  React.useEffect(() => {
    V3.get(Paths.apiMosaicTiles.expand({}))
      .then((response) => {
        setTiles(response);
      });
  }, []);

  if (tiles === null) {
    return (
      <div className="mosaic-tiles__wrapper">
        <div className="mosaic-tiles">
          <ul className="mosaic-tiles__inner">
            <PlaceholderTile />
            <PlaceholderTile />
            <PlaceholderTile />
          </ul>
        </div>
      </div>
    );
  }

  return (
    <div className="mosaic-tiles__wrapper">
      <div className="mosaic-tiles">
        <ul className="mosaic-tiles__inner">
          <MosaicTile tile={tiles.vertical_mosaic_tile} />
          <MosaicTile tile={tiles.left_square_mosaic_tile} />
          <MosaicTile tile={tiles.horizontal_mosaic_tile} />
        </ul>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/homepage_mosaic.tsx